import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DEFAULT_COMPONENT_STRINGS, } from '../../constants/strings.js';
export const ComponentStringContext = React.createContext(undefined);
export function useComponentStrings() {
    const strings = React.useContext(ComponentStringContext);
    if (!strings) {
        return DEFAULT_COMPONENT_STRINGS;
    }
    return strings;
}
export function ComponentStringsProvider({ children, strings, }) {
    return (_jsx(ComponentStringContext.Provider, { value: strings, children: children }));
}
